import script from "./AppointmentCustomerInfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentCustomerInfoCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentCustomerInfoCard.vue?vue&type=style&index=0&id=0f7eccf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7eccf2"]])

export default __exports__